/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Auth_Callback_Desktop_Success_DescInputs */

const en_common_auth_callback_desktop_success_desc = /** @type {(inputs: Common_Auth_Callback_Desktop_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can close this tab and return to the desktop app.`)
};

const zh_common_auth_callback_desktop_success_desc = /** @type {(inputs: Common_Auth_Callback_Desktop_Success_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以关闭此页面并返回桌面应用了。`)
};

/**
* | output |
* | --- |
* | "You can close this tab and return to the desktop app." |
*
* @param {Common_Auth_Callback_Desktop_Success_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_auth_callback_desktop_success_desc = /** @type {((inputs?: Common_Auth_Callback_Desktop_Success_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Auth_Callback_Desktop_Success_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_auth_callback_desktop_success_desc(inputs)
	return zh_common_auth_callback_desktop_success_desc(inputs)
});
export { common_auth_callback_desktop_success_desc as "common.auth.callback.desktop_success_desc" }